import { takeLatest, put } from 'redux-saga/effects';
import * as types from './actionTypes.errors';
import errorMessages from '../../const/errorMessages';
import getErrorMsg from '../../services/mini/getErrorMsg';
import ToasterService from '../../services/ToasterService';
import ErrorsService from '../../services/ErrorsService';
import { IBaseAction } from '../base';
import { ISentErrorParam } from './actions.errors';
import { ErrorData } from '../../models/ErrorData';


export function* watchErrors() {
    yield takeLatest<IShowErrorParam & IBaseAction>(types.ERROR_WAS_RECEIVED, showError);
    yield takeLatest<ISentErrorParam & IBaseAction>(types.SENT_ERROR_REQ, receiveError);
}
export interface IShowErrorParam {
    errObj: ErrorData
    noToaster?: boolean,
}

function* showError({ errObj, noToaster }: IShowErrorParam) {
    try {
        if (noToaster !== true) {
            if (!ErrorsService.hasError(errObj.msg)) {
                ToasterService.showError({
                    title: errObj.msg,
                    onHidden: () => {
                        // NOTE: We manually handle error messages because preventDuplicates was not working 
                        // correctly in some cases. Specifically, this issue occurred when multiple error 
                        // messages were shown for GitHub integration after the computer woke from sleep.
                        ErrorsService.deleteError(errObj.msg);
                    }
                });
                ErrorsService.addError(errObj.msg);
            }
        }
    } catch (error) {
        console.error('error', error);
    }
}

export function* showInfo(msg) {
    ToasterService.showInfo({ title: msg });
}

export function* receiveError({ error, noToaster }: ISentErrorParam) {
    yield putError(error, noToaster);
}

export function* putError(errorData: ErrorData, noToaster?: boolean) {
    const msg = getErrorMsg(errorData);
    const humanMsg = errorMessages[msg] ? errorMessages[msg] : msg;
    yield put({
        type: types.ERROR_WAS_RECEIVED,
        errObj: {
            msg: humanMsg,
        },
        noToaster
    });
    if (errorData.apiCall) {
        console.error(`Error in api call "${errorData.apiCall}":`, msg, humanMsg);
    } else {
        console.error('error', errorData.msg, humanMsg);
    }
}